var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.generatCanvas)?_c('img',{staticClass:"w-100",attrs:{"src":_vm.imgCreated,"alt":""}}):_c('div',{class:[
      _vm.smallFront
        ? 'fullNFreeN pt4 pl4'
        : _vm.miniSmallFront
        ? 'fullNFreeN pt2 pl2'
        : 'fullNFreeN pt4 pl8'
    ],style:({
      background: _vm.fullNFreeN.bgimg ? 'url(' + _vm.fullNFreeN.bgimg + ') no-repeat center' : '#fc0324',
      'background-size': '100% 100%'
    })},[_c('p',{class:[
        _vm.smallFront
          ? 'scoped_color-06 scoped_f8 ml5'
          : _vm.miniSmallFront
          ? 'scoped_color-06 scoped_f5 ml2'
          : 'scoped_color-06 f10 ml11'
      ]},[_vm._v("\n      买"+_vm._s(_vm.fullNFreeN.fullNums)+"赠"+_vm._s(_vm.fullNFreeN.freeNums)+"低至\n    ")]),_vm._v(" "),_c('p',{class:[
        _vm.smallFront
          ? 'f10 flex ai-fe scoped_color-06'
          : _vm.miniSmallFront
          ? 'scoped_f5 flex ai-fe scoped_color-06'
          : 'f17 flex ai-fe scoped_color-06'
      ]},[_vm._v("\n      ¥\n      "),_c('span',{class:[_vm.smallFront ? 'f17 lh17' : _vm.miniSmallFront ? 'f10 scoped_lh10' : 'f32 lh32']},[_vm._v("\n        "+_vm._s(_vm.fullNFreeN.sales_price.split('.')[0])+"\n      ")]),_vm._v("\n      ."+_vm._s(_vm.fullNFreeN.sales_price.split('.')[1])+"/盒\n    ")]),_vm._v(" "),_c('p',{class:[
        _vm.smallFront
          ? 'scoped_color-06 scoped_f8 ml5 td-lt'
          : _vm.miniSmallFront
          ? 'scoped_color-06 scoped_f5 ml2 td-lt'
          : 'scoped_color-06 f10 ml11 td-lt'
      ]},[_vm._v("\n      原价￥"+_vm._s(_vm.fullNFreeN.cost_price)+"/盒\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d5ca97e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/goodsFloatImg.vue
// module id = null
// module chunks = 